var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx } from "react/jsx-runtime";
import { getTheme, mergeStyles } from "@fluentui/react/lib/Styling";
import * as React from "react";
class ValidationError extends React.Component {
  render() {
    const _a = this.props, { text, children } = _a, rest = __objRest(_a, ["text", "children"]);
    const defaultContent = !!text ? text : children;
    const theme = getTheme();
    const className = mergeStyles(__spreadProps(__spreadValues({ color: theme.semanticColors.errorText }, theme.fonts.small), { paddingTop: 5 }));
    return /* @__PURE__ */ jsx("div", __spreadProps(__spreadValues({ role: "alert", className }, rest), { children: defaultContent }));
  }
}
export {
  ValidationError
};
//# sourceMappingURL=ValidationError.js.map
